const UPDATE_FILTER_DATA_RANGE = (state, payload) => {
  state.filters.dateRange = payload
}

const UPDATE_ERROR_STATE = (state, payload) => {
  state.errorState = payload
}

const UPDATE_FILTER_VIDEOS = (state, payload) => {
  state.filters.filterVideos = payload
}

const UPDATE_COMPARE_VIDEOS = (state, payload) => {
  state.filters.compareVideos = payload
}

const UPDATE_DISABLED_DATE_RANGE = (state, payload) => {
  state.disabledDateRange = payload
}

export {
  UPDATE_FILTER_DATA_RANGE,
  UPDATE_ERROR_STATE,
  UPDATE_FILTER_VIDEOS,
  UPDATE_COMPARE_VIDEOS,
  UPDATE_DISABLED_DATE_RANGE,
}
